import type { TicketStatus } from '@/lib/api/types'

export const statusLabel: Record<TicketStatus, string> = {
  open: 'Waiting on us',
  answered: 'Waiting on the customer',
  resolved: 'Resolved',
}

export const statusTone = { open: 'warning', answered: 'neutral', resolved: 'success' } as const

/** A file's size in words: "830 KB", "2.4 MB". */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} bytes`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

/** Where a ticket came from, in the conversation's header. */
export const sourceLabel = { app: 'From the app', website: 'Website enquiry', email: 'By email' } as const
